import { doPost } from 'circe/Http/saga';

export const batchSalesOrders = (formData, headers) => doPost(
  '/api/masheed/batch-sales-orders/create-shipments',
  formData,
  headers,
  {},
  OPERATIONS_EDGE,
  false,
  true,
);
